import styled from 'styled-components';

import { CopyButton } from 'components/copy-id-button';

export const Value = styled.span`
  display: inline-flex;
  align-items: center;

  &:hover ${CopyButton} {
    opacity: 1;
  }
`;

export const InlineValue = styled(Value)`
  font: normal 12px/16px ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.greys.adminGreyDark};
  padding-bottom: 4px;
  overflow-wrap: anywhere;
`;
